import {ObjectDTO} from "./object-dto";

export class SecteurDTO extends ObjectDTO{

  libelle: string;
  actif:boolean;
  code:string;

}
